import { Component, Input, HostListener, OnInit, inject } from '@angular/core';
import { DeviceService } from '../../service/device/device.service';

export enum SCREEN_SIZE {
  'mobile',
  'tablet',
  'desktop'
}

@Component({
  selector: 'app-size-detector',
  template: '',
  standalone: false
})
export class ScreenSizeDetectorComponent implements OnInit {
  @Input() breakpoints: { mobile: number; tablet: number; desktop: number } = {
    mobile: 576,
    tablet: 768,
    desktop: 1024
  };
  private deviceService = inject(DeviceService);

  ngOnInit() {
    this.detectScreenSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.detectScreenSize();
  }

  private detectScreenSize() {
    const width = window.innerWidth;
    let newSize: SCREEN_SIZE = SCREEN_SIZE.desktop;

    if (width < this.breakpoints.tablet) {
      newSize = SCREEN_SIZE.mobile;
    } else if (width < this.breakpoints.desktop) {
      newSize = SCREEN_SIZE.tablet;
    }

    this.deviceService.onResize(newSize);
  }
}
